import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import {
  TransportPlannerProfileItemBriefState,
  TransportPlannerProfileItemBriefStateModel,
} from './transport-planner-profile-item-brief.state';
import { TransportPlannerProfileDetails, TransportPlannerProfileModel } from '../models';
import { MatDialogRef } from '@angular/material/dialog';
import {
  TransportPlannerProfileItemBriefClone,
  TransportPlannerProfileItemBriefDelete,
  TransportPlannerProfileItemBriefInitialState,
  TransportPlannerProfileItemBriefLoad,
  TransportPlannerProfileItemBriefSave,
} from './transport-planner-profile-item-brief.actions';
import { ConfirmationDialogAfterClosedModel } from '../../../../../ui-kit';

@Injectable({ providedIn: 'root' })
export class TransportPlannerProfileItemBriefFacade implements LoadDataFacade, SetInitialStateFacade {
  profileId$: Observable<number> = this.store.select(TransportPlannerProfileItemBriefState.getProfileId);
  profile$: Observable<TransportPlannerProfileItemBriefStateModel> = this.store.select(
    TransportPlannerProfileItemBriefState.getState,
  );
  loaded$: Observable<boolean> = this.store.select(TransportPlannerProfileItemBriefState.getLoaded);

  constructor(private store: Store) {}

  loadAll(transportPlannerProfileId: number): void {
    this.store.dispatch(new TransportPlannerProfileItemBriefLoad(transportPlannerProfileId));
  }

  saveProfile(profile: TransportPlannerProfileDetails): void {
    this.store.dispatch(new TransportPlannerProfileItemBriefSave(profile));
  }

  cloneProfile(data: TransportPlannerProfileModel): void {
    this.store.dispatch(new TransportPlannerProfileItemBriefClone(data));
  }

  deleteProfile(profileId: number, dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>): void {
    this.store.dispatch(new TransportPlannerProfileItemBriefDelete({ dialog, profileId }));
  }

  setInitialState(): void {
    this.store.dispatch(new TransportPlannerProfileItemBriefInitialState());
  }
}
